<div class="relative flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacistName" class="cursor-pointer text-sm font-medium" i18n="@@adminCreatePharmacyFormPharmacist">
    Pharmacist Name
    <span class="text-red-600">*</span>
  </label>

  <input
    id="pharmacistName"
    type="text"
    [value]="selectedPharmacistName()"
    formControlName="pharmacist"
    placeholder="Enter pharmacist name"
    i18n-placeholder="@@adminCreatePharmacyFormPharmacistPlaceholder"
    class="w-full rounded-md border bg-gray-50 px-3 py-2 text-sm transition-colors placeholder:text-gray-400 focus:bg-white focus:outline-none"
    [class]="{
      'border-gray-300 hover:border-gray-400 focus:border-gray-600': !(
        pharmacyForm().get('pharmacist')?.invalid && pharmacyForm().get('pharmacist')?.touched
      ),
      'border-red-500 bg-red-50 focus:border-red-500':
        pharmacyForm().get('pharmacist')?.invalid && pharmacyForm().get('pharmacist')?.touched,
    }" />

  @if (loadingPharmacist()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white py-6 shadow-lg">
      <app-loading />
    </div>
  }

  @if (errorPharmacist()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      <app-error [apiError]="isArabic() ? 'حدث بعض الخطأ' : 'Some error occurred'" />
    </div>
  }

  @if (showFullNameDropdown() && fullNameResults().length > 0 && !loadingPharmacist()) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      @for (item of fullNameResults(); track item.id) {
        <button
          type="button"
          (click)="onSelectFullName(item.id.toString(), item.fullName)"
          class="block w-full cursor-pointer px-4 py-2 text-start text-sm transition-colors hover:bg-gray-50">
          {{ item.fullName }}
        </button>
      }
    </div>
  }
  @if (showFullNameDropdown() && fullNameResults().length === 0) {
    <div class="max-h-52 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
      <p
        i18n="@@noPharamciesData"
        class="mx-auto flex w-full justify-center border-b border-gray-50 px-4 py-2 text-center text-start text-sm transition-colors last:border-0 hover:bg-gray-50">
        No Pharamcy Owner matches this name
      </p>
    </div>
  }

  @if (pharmacyForm().get("pharmacist")?.invalid && pharmacyForm().get("pharmacist")?.touched) {
    <span class="text-xs text-red-600">
      @if (pharmacyForm().get("pharmacist")?.errors?.["required"]) {
        <span i18n="@@adminCreatePharmacyFormErrorPharmacistNameRequired">Pharmacist name is required</span>
      }
    </span>
  }
</div>
